import { render, staticRenderFns } from "./MonitorView.vue?vue&type=template&id=9a65c034&scoped=true"
import script from "./MonitorView.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitorView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a65c034",
  null
  
)

export default component.exports